// pt-br    ->    pt_BR
export const parseLanguageToTolqFormat = (language: string) => {
  const languages = language?.split('-');

  return languages?.length > 1
    ? `${languages?.at(0)}_${languages?.at(1)?.toLocaleUpperCase()}`
    : languages?.at(0);
};

// pt_BR -> pt-br
export const parseLanguageToHubspotFormat = (language: string) => {
  const languages = language?.split('_');

  return languages?.length > 1
    ? `${languages?.at(0)}-${languages?.at(1)?.toLocaleLowerCase()}`
    : languages?.at(0);
};
